import { IntegrationSummaryAnalyticsActionTypes } from './constants';

export const INIT_STATE = {
    errorGetShipmentsCount: null,
    loadingShipmentsCount: false,
    shipmentsCount: null,
    errorGetShipmentRatesCount: null,
    loadingShipmentRatesCount: false,
    shipmentRatesCount: null,
    errorGetAdjustmentsCount: null,
    loadingAdjustmentsCount: false,
    adjustmentsCount: null,
    errorGetShipmentsWithRatesCount: null,
    loadingShipmentsWithRatesCount: false,
    shipmentsWithRatesCount: null,
    errorGetShipmentsWithNoRatesCount: null,
    loadingShipmentsWithNoRatesCount: false,
    shipmentsWithNoRatesCount: null,
    errorGetSurchargesCount: null,
    loadingSurchargesCount: false,
    surchargesCount: null,
    errorGetNonZeroSurchargesCount: null,
    loadingNonZeroSurchargesCount: false,
    nonZeroSurchargesCount: null,
    errorGetIntegrationSummary: null,
    loadingIntegrationSummary: false,
    integrationSummary: null,
};

type IntegrationSummaryAnalyticsAction = {
    type: string,
    payload: { actionType?: string, data?: any, error?: string },
};

type State = {
    errorGetShipmentsCount?: null,
    loadingShipmentsCount: Boolean,
    shipmentsCount: any,
    errorGetShipmentRatesCount?: null,
    loadingShipmentRatesCount: Boolean,
    shipmentRatesCount: any,
    errorGetAdjustmentsCount?: null,
    loadingAdjustmentsCount: Boolean,
    adjustmentsCount: any,
    errorGetShipmentsWithRatesCount?: null,
    loadingShipmentsWithRatesCount: Boolean,
    shipmentsWithRatesCount: any,
    errorGetShipmentsWithNoRatesCount?: null,
    loadingShipmentsWithNoRatesCount: Boolean,
    shipmentsWithNoRatesCount: any,
    errorGetSurchargesCount?: null,
    loadingSurchargesCount: Boolean,
    surchargesCount: any,
    errorGetNonZeroSurchargesCount?: null,
    loadingNonZeroSurchargesCount: Boolean,
    nonZeroSurchargesCount: any,
    errorGetIntegrationSummary?: null,
    loadingIntegrationSummary: Boolean,
    integrationSummary: any,
};

const IntegrationSummaryAnalytics = (state: State = INIT_STATE, action: IntegrationSummaryAnalyticsAction): any => {
    switch (action.type) {
        case IntegrationSummaryAnalyticsActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case IntegrationSummaryAnalyticsActionTypes.GET_SHIPMENTS_COUNT: {
                    return { ...state, loadingShipmentsCount: false, shipmentsCount: action.payload.data };
                }
                case IntegrationSummaryAnalyticsActionTypes.GET_SHIPMENT_RATES_COUNT: {
                    return { ...state, loadingShipmentRatesCount: false, shipmentRatesCount: action.payload.data };
                }
                case IntegrationSummaryAnalyticsActionTypes.GET_ADJUSTMENTS_COUNT: {
                    return { ...state, loadingAdjustmentsCount: false, adjustmentsCount: action.payload.data };
                }
                case IntegrationSummaryAnalyticsActionTypes.GET_SHIPMENTS_WITH_RATES_COUNT: {
                    return { ...state, loadingShipmentsWithRatesCount: false, shipmentsWithRatesCount: action.payload.data };
                }
                case IntegrationSummaryAnalyticsActionTypes.GET_SHIPMENTS_WITH_NO_RATES_COUNT: {
                    return { ...state, loadingShipmentsWithNoRatesCount: false, shipmentsWithNoRatesCount: action.payload.data };
                }
                case IntegrationSummaryAnalyticsActionTypes.GET_SURCHARGES_COUNT: {
                    return { ...state, loadingSurchargesCount: false, surchargesCount: action.payload.data };
                }
                case IntegrationSummaryAnalyticsActionTypes.GET_NON_ZERO_SURCHARGES_COUNT: {
                    return { ...state, loadingNonZeroSurchargesCount: false, nonZeroSurchargesCount: action.payload.data };
                }
                case IntegrationSummaryAnalyticsActionTypes.GET_INTEGRATION_SUMMARY: {
                    return { ...state, loadingIntegrationSummary: false, integrationSummary: action.payload.data };
                }
                default:
                    return { ...state, 
                        loadingShipmentsCount: false, 
                        loadingShipmentRatesCount: false, 
                        loadingAdjustmentsCount: false, 
                        loadingShipmentsWithRatesCount: false, 
                        loadingShipmentsWithNoRatesCount: false, 
                        loadingSurchargesCount: false, 
                        loadingNonZeroSurchargesCount: false, 
                        loadingIntegrationSummary: false 
                    };
            }

        case IntegrationSummaryAnalyticsActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case IntegrationSummaryAnalyticsActionTypes.GET_SHIPMENTS_COUNT: {
                    return { ...state, loadingShipmentsCount: false, errorGetShipmentsCount: action.payload.error };
                }
                case IntegrationSummaryAnalyticsActionTypes.GET_SHIPMENT_RATES_COUNT: {
                    return { ...state, loadingShipmentRatesCount: false, errorGetShipmentRatesCount: action.payload.error };
                }
                case IntegrationSummaryAnalyticsActionTypes.GET_ADJUSTMENTS_COUNT: {
                    return { ...state, loadingAdjustmentsCount: false, errorGetAdjustmentsCount: action.payload.error };
                }
                case IntegrationSummaryAnalyticsActionTypes.GET_SHIPMENTS_WITH_RATES_COUNT: {
                    return { ...state, loadingShipmentsWithRatesCount: false, errorGetShipmentsWithRatesCount: action.payload.error };
                }
                case IntegrationSummaryAnalyticsActionTypes.GET_SHIPMENTS_WITH_NO_RATES_COUNT: {
                    return { ...state, loadingShipmentsWithNoRatesCount: false, errorGetShipmentsWithNoRatesCount: action.payload.error };
                }
                case IntegrationSummaryAnalyticsActionTypes.GET_SURCHARGES_COUNT: {
                    return { ...state, loadingSurchargesCount: false, errorGetSurchargesCount: action.payload.error };
                }
                case IntegrationSummaryAnalyticsActionTypes.GET_NON_ZERO_SURCHARGES_COUNT: {
                    return { ...state, loadingNonZeroSurchargesCount: false, errorGetNonZeroSurchargesCount: action.payload.error };
                }
                case IntegrationSummaryAnalyticsActionTypes.GET_INTEGRATION_SUMMARY: {
                    return { ...state, loadingIntegrationSummary: false, errorGetIntegrationSummary: action.payload.error };
                }
                default:
                    return { ...state };
            }

        case IntegrationSummaryAnalyticsActionTypes.GET_SHIPMENTS_COUNT:
            return { ...state, loadingShipmentsCount: true, shipmentsCount: null };
        case IntegrationSummaryAnalyticsActionTypes.GET_SHIPMENT_RATES_COUNT:
            return { ...state, loadingShipmentRatesCount: true, shipmentRatesCount: null };
        case IntegrationSummaryAnalyticsActionTypes.GET_ADJUSTMENTS_COUNT:
            return { ...state, loadingAdjustmentsCount: true, adjustmentsCount: null };
        case IntegrationSummaryAnalyticsActionTypes.GET_SHIPMENTS_WITH_RATES_COUNT:
            return { ...state, loadingShipmentsWithRatesCount: true, shipmentsWithRatesCount: null };
        case IntegrationSummaryAnalyticsActionTypes.GET_SHIPMENTS_WITH_NO_RATES_COUNT:
            return { ...state, loadingShipmentsWithNoRatesCount: true, shipmentsWithNoRatesCount: null };
        case IntegrationSummaryAnalyticsActionTypes.GET_INTEGRATION_SUMMARY:
            return { ...state, loadingIntegrationSummary: true, integrationSummary: null };
        case IntegrationSummaryAnalyticsActionTypes.GET_SURCHARGES_COUNT:
            return { ...state, loadingSurchargesCount: true, surchargesCount: null };
        case IntegrationSummaryAnalyticsActionTypes.GET_NON_ZERO_SURCHARGES_COUNT:
            return { ...state, loadingNonZeroSurchargesCount: true, nonZeroSurchargesCount: null };
        default:
            return { ...state };
    }
};

export default IntegrationSummaryAnalytics;
